<template>
  <section class="container">
    <div class="banner_view" ref="banner_view">
      <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item>
          <van-image :src="banner">
            <template v-slot:loading>
              <van-loading type="spinner" size="20" />
            </template>
          </van-image>
        </van-swipe-item>
        <van-swipe-item>
          <van-image :src="gift">
            <template v-slot:loading>
              <van-loading type="spinner" size="20" />
            </template>
          </van-image>
        </van-swipe-item>
        <van-swipe-item>
          <van-image :src="banner_02">
            <template v-slot:loading>
              <van-loading type="spinner" size="20" />
            </template>
          </van-image>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="form_view">
      <van-cell-group>
        <van-field v-model="formData.username" label="姓名" placeholder="请输入用户名" :error-message="rule.username" />
        <van-field v-model="formData.liftTime" placeholder="请选择提车时间" readonly clickable
          @click="liftTimeTemp.liftTimePop = true" label="提车时间" error-message="" />
        <van-field v-model="formData.vehiclePrice" readonly clickable label="车价"
          @touchstart.native.stop="vehiclePriceIsShow = true" placeholder="请输入购买时的车价" error-message="">
          <span slot="right-icon">万元</span>
        </van-field>
        <van-field v-model="formData.plateNumber" label="车牌号" placeholder="请输入车牌号" :error-message="rule.plateNumber" />
        <van-field v-model="formData.phone" readonly clickable label="手机号码" placeholder="请输入手机号码"
          @touchstart.native.stop="NKIsShow = true" :error-message="rule.phone" />
        <!-- <van-cell-group>
          <van-field v-model="sms" center clearable label="短信验证码" placeholder="请输入短信验证码">
            <van-button slot="button" size="small" type="info">发送验证码</van-button>
          </van-field>
        </van-cell-group> -->
      </van-cell-group>
      <div class="fix-bottom">
        <van-submit-bar :price="2000" :disabled="!checked" button-text="立即办理" @submit="onSubmit">
          <div slot="top" class="user_instructions">
            <van-checkbox v-model="checked" icon-size="14px" shape="square">
              <span style="font-size:12px;">我已阅读并同意</span>
              <a href="http://www.shangbiao.com/corp/agreement" target="_blank" rel="noopener noreferrer">
                <span style="color:#fd5f43;">《用户注册协议》</span>
                <span style="color:#fd5f43;">《投保须知》</span>
              </a>
            </van-checkbox>
          </div>
          <div class="product-premium">￥20/年起</div>
        </van-submit-bar>
      </div>
    </div>
    <div class="introduce_view">
      <van-panel>
        <div slot="header" class="wx-panel__header">
          <h3 class="ws-panel__title">理赔流程</h3>
        </div>
        <div class="product-claim-info__content">
          <div class="product-claim-info__claim-step">
            <div class="ws-step__step-item">
              <div class="ws-step__step-header">
                <i class="ws-mark">1</i>
                <h3 class="ws-step__header-text">第1步: 理赔申请</h3>
              </div>
              <div class="ws-step__step-content">
                通过关注微信公众号在线申请理赔。
              </div>
            </div>
            <div class="ws-step__step-item">
              <div class="ws-step__step-header">
                <i class="ws-mark">2</i>
                <h3 class="ws-step__header-text">第2步: 提交理赔资料</h3>
              </div>
              <div class="ws-step__step-content">
                根据安迅特定制的理赔服务方案提交资料。
              </div>
            </div>
            <div class="ws-step__step-item">
              <div class="ws-step__step-header">
                <i class="ws-mark">3</i>
                <h3 class="ws-step__header-text">第3步: 完成理赔</h3>
              </div>
              <div class="ws-step__step-content" style="border-left: none;">
                根据审核结果将理赔款项支付到被保人指定账户。
              </div>
            </div>
          </div>
        </div>
        <div class="introduce_main">
          <div class="carInsurance">
            <van-image :src="Glass">
              <template v-slot:loading>
                <van-loading type="spinner" size="20" />
              </template>
            </van-image>
          </div>
        </div>
      </van-panel>

      <div class="introduce_text">
        <div class="introduce_label">
          <svg-icon icon-class="message" />
          保障什么？
        </div>
        <div class="introduce_text_content">
          成功加入玻璃保3天后服务生效，您的车辆在全国任意停车场停车时，出现汽车前、后挡风玻璃，侧窗玻璃碎裂将获得保障。
        </div>
      </div>
      <div class="introduce_text">
        <div class="introduce_label">
          <svg-icon icon-class="peoples" />
          为什么买？
        </div>
        <div class="introduce_text_content">
          玻璃属车辆易碎件，车主和车分离的时间远大于驾驶的时间，车子在停车场玻璃破碎，保险公司是不于赔付的。参加了玻璃保，车辆在全国所有的停车场，玻璃破损，所需修复费用，将按实际修复费用予以补偿。车辆每年最高补偿限额5000元！
        </div>
      </div>
      <div class="introduce_text">
        <div class="introduce_label">
          <svg-icon icon-class="peoples" />
          如何理赔？
        </div>
        <div class="introduce_text_content">
          1、网上提出申报。2、上传破损玻璃照片。3、提供修理清单。4、修理发票5提供卡号或其他收款方式。5、单证最终提交日为车辆玻璃破损之日起六个月内。
        </div>
      </div>
    </div>

    <div>
      <van-divider>
        <div style="text-align:center;">
          本产品由安迅特汽车服务有限公司提供服务<br />
          本站由江苏九比特信息系统有限公司提供支持<br />
          Copyright © 江苏九比特信息系统有限公司<br />
          All Rights Reserved 苏ICP备15036890号<br />
        </div>
      </van-divider>
    </div>
    <!-- <div class="logo_box">
      <van-image :src="logo">
        <template v-slot:loading>
          <van-loading type="spinner" size="20" />
        </template>
      </van-image>
    </div> -->
    <!-- 数字键盘 -->
    <van-number-keyboard :show="NKIsShow" v-model="formData.phone" safe-area-inset-bottom close-button-text="完成"
      @blur="NKIsShow = false" />
    <!-- 车辆价格 -->
    <van-number-keyboard :show="vehiclePriceIsShow" :maxlength="6" extra-key="." safe-area-inset-bottom
      v-model="formData.vehiclePrice" close-button-text="完成" @blur="vehiclePriceIsShow = false" />
    <!-- 时间选择器 -->
    <van-popup v-model="liftTimeTemp.liftTimePop" label="提车时间" position="bottom" :overlay="true">
      <van-datetime-picker v-model="liftTimeTemp.liftTime" label="提车时间" :min-date="liftTimeTemp.minDate"
        @cancel="liftTimeTemp.liftTimePop = false" @confirm="liftTimeConfirm" @change="liftTimeChange" type="date" />
    </van-popup>
  </section>
</template>

<script>
import { Loading, Field, Divider, NumberKeyboard, Panel, Swipe, SwipeItem, Checkbox, CheckboxGroup, SubmitBar, Step, Steps, DatetimePicker, Popup } from 'vant'
import { getUA } from 'mobile-device-detect'
import logo from '@/assets/insurance_images/logo.png'
import banner from '@/assets/insurance_images/abanner@2x.jpg'
import gift from '@/assets/insurance_images/get_gift.jpg'
import Glass from '@/assets/insurance_images/eightCar.gif'
import banner_02 from '@/assets/insurance_images/abanner_02@2x.jpg'
import { weixinPay, unifiedOrder, getAccessByCode } from '@/api/wechat'
import config from '@/config/index'
import { parseTime, getUrlParam } from '@/utils'
import { mapGetters } from 'vuex'
export default {
  name: 'Vehicle-insurance',
  computed: {
    ...mapGetters(['wx_userInfo'])
  },
  components: {
    [Loading.name]: Loading,
    [Field.name]: Field,
    [Divider.name]: Divider,
    [NumberKeyboard.name]: NumberKeyboard,
    [Panel.name]: Panel,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [SubmitBar.name]: SubmitBar,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup
  },
  data () {
    return {
      logo,
      banner,
      Glass,
      gift,
      banner_02,
      checked: false,
      NKIsShow: false,
      scrollTop: 0,
      vehiclePriceIsShow: false,
      liftTimeTemp: {
        liftTime: [],
        liftTimePop: false,
        minDate: new Date(2000, 0, 1)
      },
      formData: {
        orderId: '',
        username: '',
        parentId: '',
        phone: '', //联系方式
        email: '', //邮箱
        sex: 1, //性别
        plateNumber: '', //车牌号
        vehicleType: '', //车牌类型
        vehiclePrice: '', //车辆价格
        chargeMoney: 20, //车险价格
        payMoney: 20, //支付价格
        payTime: '', //支付时间
        payType: 1, //支付类型
        payStatus: 0, //支付状态
        startTime: '', //车险生效时间
        endTime: '', //车险失效时间
        insuranceType: 1, //车险类型
        liftTime: '', //提车时间
        province: '', //省份
        city: '', //城市
        auditStatus: 0 //审核状态
      },
      rule: {
        username: '',
        plateNumber: '',
        phone: ''
      },
      getCodeLoading: null, //获取code
      unifiedOrderLoading: null //下单
    }
  },
  mounted () {
    this.getCode()
  },
  methods: {
    getCode () {
      let _this = this
      const AppId = _this.$enumObject.providerConfig[config.projectName].AppIds
      const code = getUrlParam('code')
      _this.formData.parentId = getUrlParam('promote') //获取推广码
      let local = window.location.href
      if (code == null || code == '') {
        getAccessByCode(AppId, local)//获取微信code
      } else {
        // 获取openid
        _this.getCodeLoading = _this.$toast.loading('正在获取用户信息...')
        let params = {
          code
        }
        _this.$store
          .dispatch('wxAuthentication', params)
          .then(response => {
            let data = response.body
            _this.getCodeLoading.clear()
            // 如果code过期则重新进入页面获取
            if (!data.access_token) {
              if (local.indexOf('?') != -1) {
                local = local.split('?')[0]
              }
              // 重新获取code
              if (_this.formData.parentId) {
                window.location.href = `${local}?promote=${_this.formData.parentId}`
              } else {
                window.location.href = local
              }
              return
            }
            // code正常则保存微信鉴权和用户数据
          })
          .catch(error => {
            _this.getCodeLoading.clear()
            _this.$notify({
              type: 'danger',
              message: error
            })
          })
      }
    },
    liftTimeChange (e) {
      let timeArr = e.getValues() //["2019", "03", "22"]
      this.formData.liftTime = `${timeArr[0]}-${timeArr[1]}-${timeArr[2]}`
    },
    liftTimeConfirm (val) {
      this.formData.liftTime = parseTime(val, '{y}-{m}-{d}')
      this.liftTimeTemp.liftTimePop = false
    },
    // 定位到顶部
    toTop () {
      let elHeight = this.$refs.banner_view.getBoundingClientRect().height
      document.documentElement.scrollTop = document.body.scrollTop = elHeight
    },
    // 微信支付(支付成功:存储完成订单信息;取消支付:存储进行中订单;)
    onSubmit () {
      let _this = this
      _this.unifiedOrderLoading = _this.$toast.loading('正在下单...')
      let params = {
        // 流水参数
        orderId: _this.formData.orderId, //订单号
        accountId: _this.wx_userInfo.unionid, //该账户Id
        account: _this.formData.username.trim(), //账户名
        parentId: _this.formData.parentId, //父级id
        phone: _this.formData.phone, //联系方式
        email: _this.formData.email, //邮箱
        sex: 1, //性别
        plateNumber: _this.formData.plateNumber.trim().toUpperCase(), //车牌号
        vehicleType: _this.formData.vehicleType, //车牌类型
        vehiclePrice: _this.formData.vehiclePrice, //车辆价格
        chargeMoney: _this.formData.chargeMoney, //车险价格
        payMoney: _this.formData.payMoney, //支付价格
        payTime: _this.formData.payTime, //支付时间
        payType: _this.formData.payType, //支付类型
        payStatus: _this.formData.payStatus, //支付状态
        startTime: _this.formData.startTime, //车险生效时间
        endTime: _this.formData.endTime, //车险失效时间
        insuranceType: _this.formData.insuranceType, //车险类型
        liftTime: parseTime(new Date(_this.formData.liftTime)), //提车时间
        province: _this.formData.province, //省份
        city: _this.formData.city, //城市
        auditStatus: _this.formData.auditStatus, //审核状态
        // 下单参数
        deviceInfo: 'WEB', //设备号
        body: '安迅特汽车服务-汽车玻璃保', //商品简单描述，该字段请按照规范传递，具体请见
        detail: `${_this.formData.plateNumber}-汽车玻璃保`, //	商品详细描述，对于使用单品优惠的商户，该字段必须按照规范上传
        attach: '汽车玻璃保', //附加数据，在查询API和支付通知中原样返回，可作为自定义参数使用
        outTradeNo: _this.formData.orderId, //商户系统内部订单号，要求32个字符内，只能是数字、大小写字母_-|* 且在同一个商户号下唯一
        feeType: 'CNY', //符合ISO 4217标准的三位字母代码，默认人民币
        totalFee: 1, //	订单总金额，单位为分
        spbillCreateIp: '127.0.0.1', //	支持IPV4和IPV6两种格式的IP地址。用户的客户端IP this.getUserIP(ip => ip)
        timeStart: parseTime(new Date(),
          '{y}{m}{d}{h}{i}{s}'), //订单生成时间，格式为yyyyMMddHHmmss，如2009年12月25日9点10分10秒表示为20091225091010。其他详见
        goodsTag: '', //订单优惠标记，使用代金券或立减优惠功能时需要的参数，说明详见
        notifyUrl: `${config.authBaseURL}/weChat/wx/warrantyNotifyUrl`, //异步接收微信支付结果通知的回调地址，通知url必须为外网可访问的url，不能携带参数
        tradeType: 'JSAPI', //JSAPI -JSAPI支付 NATIVE -Native支付 APP -APP支付
        productId: '', //trade_type=NATIVE时，此参数必传。此参数为二维码中包含的商品ID，商户自行定义。
        limitPay: '', //上传此参数no_credit--可限制用户不能使用信用卡支付
        openid: _this.wx_userInfo ? _this.wx_userInfo.openid : '', //trade_type=JSAPI时（即JSAPI支付），此参数必传，此参数为微信用户在商户对应appid下的唯一标识。
        subOpenid: '', //openid
        receipt: '', //Y，传入Y时，支付成功消息和支付详情页将出现开票入口。需要在微信支付商户平台或微信公众平台开通电子发票功能，传此字段才可生效
        sceneInfo: '', //该字段常用于线下活动时的场景信息上报，支持上报实际门店信息，商户也可以按需求自己上报相关信息。该字段为JSON对象数据，对象格式为{"store_info":{"id": "门店ID","name": "名称","area_code": "编码","address": "地址" }} ，字段详细说明请点击行前的+展开
        mac: getUA, //设备号
        parkId: '', //车场编号
        version: '1.0', //版本号
        parkName: '' //停车场名称
      }
      if (_this.validator(params)) {
        unifiedOrder(params)
          .then(response => {
            let data = response.body
            _this.unifiedOrderLoading.clear()
            let params = {
              appId: data.appId,
              timeStamp: data.timeStamp,
              nonceStr: data.nonceStr,
              package: data.packages,
              signType: data.signType,
              paySign: data.paySign
            }
            let callBack = res => {
              if (res.err_msg == 'get_brand_wcpay_request:ok') {
                _this.$router.push('/result-page')
              } else if (res.err_msg == 'get_brand_wcpay_request:fail') {
                _this.$router.push({
                  path: '/result-page',
                  query: {
                    err_msg: res.err_msg
                  }
                })
              } else {
                _this.$router.push('/vehicle-insurance')
              }
            }
            weixinPay(params, callBack)
          })
          .catch(error => {
            _this.unifiedOrderLoading.clear()
            _this.$notify({
              type: 'danger',
              message: error
            })
          })
      } else {
        _this.toTop()
        _this.unifiedOrderLoading.clear()
      }
    },
    validator (params) {
      let isSuccess = true
      if (params.account) {
        //用户名存在
        this.rule.username = ''
      } else {
        this.rule.username = '请输入用户名'
        isSuccess = false
      }
      let plateNumberReg = new RegExp(
        '^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([DF]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DF]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$'
      )
      if (params.plateNumber != null && params.plateNumber != '') {
        //车牌号存在
        this.rule.plateNumber = ''
        if (!plateNumberReg.test(params.plateNumber)) {
          this.rule.plateNumber = '请输入正确的车牌号'
          isSuccess = false
        }
      } else {
        this.rule.plateNumber = '请输入车牌号'
        isSuccess = false
      }

      if (params.phone != null && params.phone != '') {
        //联系号码存在
        this.rule.phone = ''
        if (!/^1[3456789]\d{9}$/.test(params.phone)) {
          this.rule.phone = '请输入正确的手机号码'
          isSuccess = false
        }
      } else {
        this.rule.phone = '请输入手机号码'
        isSuccess = false
      }
      return isSuccess
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  background-color: rgb(248, 248, 248);
  margin-bottom: 100px;

  .form_view {
    margin-top: 20px;
  }

  .banner_view {
    width: 100%;
  }

  .introduce_view {
    margin-top: 20px;
    background-color: #fff;
    padding-bottom: 10px;
    font-family: PingFangSC-Regular, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #4e4e4e;

    .wx-panel__header {
      display: flex;
      align-items: center;
      height: 50px;
      padding: 0 0.3rem;
      border-bottom: 1px solid #cfcfcf;

      .ws-panel__title {
        flex: 1;
        font-size: 16px;
        font-weight: 700;
      }
    }

    .product-claim-info__content {
      padding: 18px 15px;
      font-size: 14px;

      .ws-mark {
        font-size: 12px;
        width: 0.32rem;
        height: 0.32rem;
        line-height: 0.32rem;
        border-radius: 50%;
        text-align: center;
        vertical-align: middle;
        font-style: normal;
      }

      .product-claim-info__claim-step {
        padding: 0;
        margin: 0;
        box-sizing: border-box;
        border: 0;
        font-size: 100%;
        vertical-align: baseline;

        .ws-step__step-header {
          display: flex;
          align-items: center;
          margin-bottom: 0.12rem;

          .ws-mark {
            background-color: #83bbff;
            color: #fff;
            margin-right: 0.16rem;
          }

          .ws-step__header-text {
            font-weight: 700;
            flex: 1;
          }
        }

        .ws-step__step-content {
          word-break: break-all;
          line-height: 1.8;
          border-left: 1px solid #83bbff;
          padding-left: 0.3rem;
          padding-bottom: 0.26rem;
          margin-left: 0.16rem;
          margin-bottom: 0.06rem;
        }
      }
    }

    .carInsurance {
      background: url("~@/assets/insurance_images/half.png") no-repeat;
      background-size: 100% 100%;
    }

    .introduce_main {
      background: url("~@/assets/insurance_images/xzbg.png") no-repeat;
      background-color: #fff;
      background-size: 100% 100%;
    }

    .introduce_text {
      .introduce_label {
        position: relative;
        margin: 20px 0 0 10px;
        width: 115px;
        height: 32px;
        background-color: #2095f4;
        border-radius: 18px;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        line-height: 31px;
        text-align: center;
        padding-left: 10px;
      }

      .introduce_text_content {
        position: relative;
        font-size: 14px;
        color: #242424;
        line-height: 28px;
        padding: 10px;
      }
    }
  }

  .fix-bottom {
    position: fixed;
    height: 100px;
    width: 100%;
    left: 0;
    bottom: 0;
    z-index: 10;
    background-color: #fff;

    .product-premium {
      font-size: 20px;
      color: #ffa419;
      margin-left: 15px;
      letter-spacing: 1px;
    }

    .user_instructions {
      padding: 10px;
      display: flex;
      justify-content: center;

      a {
        font-size: 12px;
      }
    }
  }

  .logo_box {
    width: 75px;
    margin: 0 auto;
    font-size: 12px;
  }
}
</style>